module.exports = __webpack_public_path__ + "img/old_share.c86a895d.png";